import { render, staticRenderFns } from "./TasanteaProductDetail.vue?vue&type=template&id=0ed28b60&scoped=true"
import script from "./TasanteaProductDetail.vue?vue&type=script&lang=js"
export * from "./TasanteaProductDetail.vue?vue&type=script&lang=js"
import style0 from "./TasanteaProductDetail.vue?vue&type=style&index=0&id=0ed28b60&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed28b60",
  null
  
)

export default component.exports